import { Spinner } from '@wartek-id/spinner'

import type { FC } from 'react'

interface StateLoadingProps {}

const StateLoading: FC<StateLoadingProps> = ({}) => {
  return (
    <div className="flex justify-center p-6" data-testid="loading-spinner">
      <Spinner />
    </div>
  )
}
export default StateLoading
